import { createStore } from 'vuex';

export default createStore({
  state() {
    return {
      isShowRightBar: false,
      isHighModal: true,
      currentEl: {},
      currentProgressImage: [],
      numberType: '', // 数值类型
      currentRotateImage: new Map(),
      currentBarImage: [],
      isShowSelectBase: false,
      isAddUnit: false,
      bgImgObj: {},
      isShowProperty: true,
      currentSectorImage: new Map(),
    };
  },
  mutations: {
    changeRightBar(state, value) {
      state.isShowRightBar = value;
    },
    changecurrentEl(state, currentEl) {
      state.currentEl = currentEl;
    },
    changecurrentProgress(state, currentProgressImage) {
      if (state.currentProgressImage.length > 0) {
        state.currentProgressImage[currentProgressImage.index] = currentProgressImage;
      } else {
        state.currentProgressImage.push(currentProgressImage);
      }
    },
    changeImageSrc(state, data) {
      if (state.currentEl.option) {
        state.currentEl.option[data.index].src = data.src;
      } else {
        state.bgImgObj.option[data.index].src = data.src;
      }
    },
    syncImage(state, infos) {
      state.currentEl.option = infos;
    },
    changeCurrentBarImage(state, currentBarImage) {
      if (state.currentBarImage.length > 0) {
        state.currentBarImage[currentBarImage.index] = currentBarImage;
      } else {
        state.currentBarImage.push(currentBarImage);
      }
    },
    changeCurrentRotateImage(state, currentRotateImage) {
      if (currentRotateImage.src === '') {
        state.currentRotateImage.delete(currentRotateImage.id);
      } else {
        if (!state.currentRotateImage.has(currentRotateImage.id)) {
          state.currentRotateImage.set(currentRotateImage.id, JSON.stringify(currentRotateImage));
        }
      }
    },
    changeCurrentSectorImage(state, currentSectorImage) {
      if (currentSectorImage.src === '') {
        state.currentSectorImage.delete(currentSectorImage.id);
      } else {
        if (!state.currentSectorImage.has(currentSectorImage.id)) {
          state.currentSectorImage.set(currentSectorImage.id, JSON.stringify(currentSectorImage));
        }
      }
    },
    HightModalSwitch(state, data) {
      if (data === 2) {
        state.isHighModal = true;
      } else {
        state.isHighModal = false;
      }
    },
    setNumberType(state, numberType) {
      state.numberType = numberType;
    },
    setSelectBase(state, isShowSelectBase) {
      state.isShowSelectBase = isShowSelectBase;
    },
    changeEditMode(state, data) {
      state.isAddUnit = data;
    },
    setBgImgObj(state, bgImgObj) {
      state.bgImgObj = bgImgObj;
    },
    // 解决用户创建元素的时候，不选择图层类型导致其他已创建元素属性无法显示
    changeIsShowProperty(state, isShow) {
      state.isShowProperty = isShow;
    },
  },
  actions: {},
  modules: {},
});
